import React from 'react';
import {IDiplomatFile} from 'types/DiplomatFile';

export const directoryListingContext = React.createContext<
   | {
        path: string | undefined;
        request: (path?: string) => void;
        selected: IDiplomatFile | undefined;
        setSelected: (path: IDiplomatFile) => void;
     }
   | undefined
   | null
>(null);

export const DirectoryListingProvider = directoryListingContext.Provider;
